// extracted by mini-css-extract-plugin
module.exports = {"navHeight":"4.5rem","title":"complete_title__FxWYU"};